import { render, staticRenderFns } from "./FactorList.vue?vue&type=template&id=754b5b18&scoped=true&lang=pug"
import script from "./FactorList.vue?vue&type=script&lang=js"
export * from "./FactorList.vue?vue&type=script&lang=js"
import style0 from "./FactorList.vue?vue&type=style&index=0&id=754b5b18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "754b5b18",
  null
  
)

export default component.exports